module.exports = __webpack_public_path__ + "d4263beff3f0c19800cfe210c8b6e03d.svg";